<template>
  <div id="stickprov-create-modal">

    <ErrorPopup
      :error="error"
    />

    <memlist-modal ref="stickprov-modal" size="xl">
      <StickprovWizard 
        @stickprovCreated="created"
      />
    </memlist-modal>

  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';


import StickprovWizard from './StickprovWizard.vue';
import RightModalSaveAndCloseButtons from '@/view/components/buttons/RightModalSaveAndCloseButtons.vue';
import ErrorPopup from '@/view/components/ErrorPopup.vue';

export default {
  name: 'StickprovCreateModal',
  components: {
    StickprovWizard,
    ErrorPopup,
    RightModalSaveAndCloseButtons
  },
  mixins: [ toasts ],
  computed: {
    
    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'pages', 'isTHS']),

  },
  props: [],
  emits: ['created'],
  async mounted() {

  },
  methods: {
    created(item) {
      this.$refs['stickprov-modal'].hide();
      this.$emit('created', item);
    },
    on_cancel() {
      this.$refs['stickprov-modal'].hide();
    },

    show() {
      this.$refs['stickprov-modal'].show();
    },

  },
  data() {
    return {
      error: null
    };
  },
  watch: {
    
  },

};
</script>
